/* unplugin-vue-components disabled */import { render } from "./CollectUserDevice.vue?vue&type=template&id=186f3a10&scoped=true"
import script from "./CollectUserDevice.vue?vue&type=script&lang=js"
export * from "./CollectUserDevice.vue?vue&type=script&lang=js"

import "./CollectUserDevice.vue?vue&type=style&index=0&id=186f3a10&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-186f3a10"]])

export default __exports__